
    import Ember from 'ember';
    import "coffeescripts/ember/shared/helpers/common";
import "i18n!screenreader_gradebook.components.grading_cell";

    Ember.TEMPLATES['components/grading-cell'] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data
) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("\n  ");
  data.buffer.push(escapeExpression((helper = helpers['fast-select'] || (depth0 && depth0['fast-select']),options={hash:{
    'id': ("input-id"),
    'items': ("passFailGrades"),
    'value': ("value")
  },hashTypes:{'id': "ID",'items': "ID",'value': "ID"},hashContexts:{'id': depth0,'items': depth0,'value': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "fast-select", options))));
  data.buffer.push("\n");
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("\n  ");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'value': ("value"),
    'id': ("input-id"),
    'type': ("text"),
    'disabled': ("isInPastGradingPeriodAndNotAdmin")
  },hashTypes:{'value': "ID",'id': "ID",'type': "STRING",'disabled': "ID"},hashContexts:{'value': depth0,'id': depth0,'type': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("\n");
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = '', stack1, helper, options;
  data.buffer.push("\n  <div class=\"deduction-box\">\n    <div class=\"deduction-box-labels\">\n      <div class=\"submission_late_penalty\">\n        ");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "late_penalty_9c312b22", "Late Penalty", options) : helperMissing.call(depth0, "t", "late_penalty_9c312b22", "Late Penalty", options))));
  data.buffer.push("\n      </div>\n      <div class=\"submission_final_grade\">\n        ");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "final_grade_4d7f6545", "Final Grade", options) : helperMissing.call(depth0, "t", "final_grade_4d7f6545", "Final Grade", options))));
  data.buffer.push("\n      </div>\n    </div>\n    <div class=\"deduction-box-values\">\n      <div class=\"submission_late_penalty\">\n        <strong>");
  stack1 = helpers._triageMustache.call(depth0, "late_penalty", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong>\n      </div>\n      <div class=\"submission_final_grade\">\n        <strong>");
  stack1 = helpers._triageMustache.call(depth0, "final_grade", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("</strong>\n      </div>\n    </div>\n  </div>\n");
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = '', helper, options;
  data.buffer.push("\n<div class=\"checkbox\">\n  <label class=\"checkbox\">\n    ");
  data.buffer.push(escapeExpression((helper = helpers.input || (depth0 && depth0.input),options={hash:{
    'type': ("checkbox"),
    'id': ("submission-excused"),
    'name': ("submission-excused"),
    'checked': ("excused"),
    'disabled': ("isInPastGradingPeriodAndNotAdmin")
  },hashTypes:{'type': "STRING",'id': "STRING",'name': "STRING",'checked': "ID",'disabled': "ID"},hashContexts:{'type': depth0,'id': depth0,'name': depth0,'checked': depth0,'disabled': depth0},contexts:[],types:[],data:data},helper ? helper.call(depth0, options) : helperMissing.call(depth0, "input", options))));
  data.buffer.push("\n    ");
  data.buffer.push(escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (false)
  },hashTypes:{'i18n_inferred_key': "BOOLEAN"},hashContexts:{'i18n_inferred_key': depth0},contexts:[depth0,depth0],types:["STRING","STRING"],data:data},helper ? helper.call(depth0, "excuse_this_assignment_for_the_selected_student_af04e132", "Excuse This Assignment for the Selected Student", options) : helperMissing.call(depth0, "t", "excuse_this_assignment_for_the_selected_student_af04e132", "Excuse This Assignment for the Selected Student", options))));
  data.buffer.push("\n  </label>\n</div>\n");
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, "isPassFail", {hash:{},hashTypes:{},hashContexts:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n");
  stack1 = helpers._triageMustache.call(depth0, "outOfText", {hash:{},hashTypes:{},hashContexts:{},contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n\n");
  stack1 = helpers['if'].call(depth0, "submission.late", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(5, program5, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n\n");
  stack1 = helpers.unless.call(depth0, "isPassFail", {hash:{},hashTypes:{},hashContexts:{},inverse:self.noop,fn:self.program(7, program7, data),contexts:[depth0],types:["ID"],data:data});
  if(stack1 || stack1 === 0) { data.buffer.push(stack1); }
  data.buffer.push("\n");
  return buffer;
  
});
  